import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const SamenwerkingenPage = () => {
  const partners = [
    {
      type: 'Gemeenten',
      icon: 'ri-government-line',
      beschrijving: 'Samenwerking met lokale overheden voor structurele ondersteuning',
      voordelen: [
        'Lokale kennis en netwerken',
        'Subsidie en financiële ondersteuning',
        'Beleidsontwikkeling en implementatie',
        'Duurzame impact in de gemeenschap'
      ]
    },
    {
      type: 'Scholen',
      icon: 'ri-school-line',
      beschrijving: 'Directe samenwerking met onderwijsinstellingen',
      voordelen: [
        'Vroege signalering van thuiszitters',
        'Soepele terugkeer naar onderwijs',
        'Kennisdeling en training docenten',
        'Preventieve programma\'s'
      ]
    },
    {
      type: 'Zorgorganisaties',
      icon: 'ri-heart-pulse-line',
      beschrijving: 'Holistische benadering met zorgpartners',
      voordelen: [
        'Geïntegreerde zorg en onderwijs',
        'Specialistische ondersteuning',
        'Multidisciplinaire teams',
        'Complexe problematiek aanpakken'
      ]
    },
    {
      type: 'Onderwijsnetwerken',
      icon: 'ri-links-line',
      beschrijving: 'Regionale en landelijke onderwijsverbanden',
      voordelen: [
        'Kennisuitwisseling en best practices',
        'Schaalvergroting van impact',
        'Innovatie en onderzoek',
        'Landelijke dekking'
      ]
    }
  ];

  const subsidies = [
    {
      naam: 'Gemeentelijke Jeugdzorg',
      beschrijving: 'Financiering voor lokale jeugdzorginitiatieven',
      focus: 'Preventie en vroege interventie',
      bedrag: '€25.000 - €100.000'
    },
    {
      naam: 'Onderwijskansenbeleid',
      beschrijving: 'Subsidie voor gelijke onderwijskansen',
      focus: 'Thuiszittende jongeren',
      bedrag: '€50.000 - €200.000'
    },
    {
      naam: 'Europese Sociale Fondsen',
      beschrijving: 'EU-financiering voor sociale innovatie',
      focus: 'Arbeidsmarktparticipatie jongeren',
      bedrag: '€100.000 - €500.000'
    },
    {
      naam: 'Innovatiefonds Onderwijs',
      beschrijving: 'Financiering voor onderwijsinnovaties',
      focus: 'Nieuwe methodieken en aanpakken',
      bedrag: '€75.000 - €300.000'
    }
  ];

  const succesverhalen = [
    {
      gemeente: 'Amsterdam',
      resultaat: '150 jongeren begeleid',
      periode: '2022-2024',
      impact: '78% succesvol terug naar school',
      quote: 'HerStart heeft een cruciale rol gespeeld in onze aanpak van jeugdwerkloosheid.'
    },
    {
      gemeente: 'Utrecht',
      resultaat: '95 jongeren begeleid',
      periode: '2023-2024',
      impact: '85% verhoogd zelfvertrouwen',
      quote: 'De samenwerking met HerStart heeft onze jeugdzorg versterkt.'
    },
    {
      gemeente: 'Rotterdam',
      resultaat: '200 jongeren begeleid',
      periode: '2021-2024',
      impact: '82% duurzame schooldeelname',
      quote: 'Een bewezen aanpak die echt verschil maakt voor onze jongeren.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Sectie */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/65c22d56684988f139ea004bdbcc413a.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-gray-900/50"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Partners
            </h1>
            <p className="text-xl md:text-2xl text-gray-100 leading-relaxed">
              Samen bouwen we aan een toekomst waarin elke jongere de kans krijgt 
              om zijn of haar potentieel te ontwikkelen in het onderwijs.
            </p>
          </div>
        </div>
      </section>

      {/* Onze Partners */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Onze Partners
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              HerStart werkt samen met verschillende organisaties om een breed netwerk 
              van ondersteuning te bieden aan thuiszittende jongeren.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${partner.icon} text-orange-500 text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {partner.type}
                  </h3>
                </div>
                <p className="text-gray-600 mb-4">
                  {partner.beschrijving}
                </p>
                <div className="space-y-2">
                  {partner.voordelen.map((voordeel, vIndex) => (
                    <div key={vIndex} className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                      <span className="text-gray-700 text-sm">{voordeel}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Groepstraining Callout */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-green-50 border border-green-200 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <div className="w-14 h-14 bg-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-presentation-line text-white text-2xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                Groepstraining op locatie voor scholen &amp; gemeenten
              </h3>
              <p className="text-gray-600 text-sm">
                Wij brengen onze bewezen <strong>Sterk in je Zelf</strong> training rechtstreeks naar uw school of instelling. Volledig maatwerk, voor groepen van 6 tot 20 leerlingen, inclusief voortgangsrapportage.
              </p>
            </div>
            <Link
              to="/trainingen"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-3 rounded-lg font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
              Meer informatie
            </Link>
          </div>
        </div>
      </section>

      {/* Subsidies en Financiering */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Subsidies & Financiering
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Dankzij verschillende subsidies en financieringsvormen kunnen we 
              onze programma's toegankelijk maken voor alle jongeren die hulp nodig hebben.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {subsidies.map((subsidie, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {subsidie.naam}
                </h3>
                <p className="text-gray-600 mb-4">
                  {subsidie.beschrijving}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm font-medium text-gray-700">Focus:</span>
                    <span className="text-sm text-gray-600">{subsidie.focus}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm font-medium text-gray-700">Bedrag:</span>
                    <span className="text-sm font-semibold text-green-600">{subsidie.bedrag}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">
              Wilt u meer weten over financieringsmogelijkheden voor uw organisatie?
            </p>
            <Button href="/contact?onderwerp=samenwerking" variant="primary" size="lg">
              Neem Contact Op
            </Button>
          </div>
        </div>
      </section>

      {/* Succesverhalen */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Succesverhalen uit de Praktijk
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Onze samenwerkingen hebben al geleid tot concrete resultaten 
              in verschillende gemeenten en regio's.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {succesverhalen.map((verhaal, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <div className="text-center mb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {verhaal.gemeente}
                  </h3>
                  <span className="text-sm text-gray-600">{verhaal.periode}</span>
                </div>
                
                <div className="space-y-3 mb-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-orange-500 mb-1">
                      {verhaal.resultaat}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-semibold text-green-600">
                      {verhaal.impact}
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-4">
                  <i className="ri-double-quotes-l text-orange-500 text-xl mb-2"></i>
                  <p className="text-gray-700 italic text-sm">
                    "{verhaal.quote}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Samenwerking Starten */}
      <section className="py-16 bg-green-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Start een Samenwerking
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                Bent u werkzaam bij een gemeente, school of zorgorganisatie en wilt u 
                samenwerken met HerStart? We bespreken graag de mogelijkheden.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Gratis Kennismaking</h4>
                    <p className="text-gray-600">We plannen een vrijblijvend gesprek om uw behoeften te bespreken</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Maatwerk Oplossingen</h4>
                    <p className="text-gray-600">Elk programma wordt aangepast aan uw specifieke situatie</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Bewezen Resultaten</h4>
                    <p className="text-gray-600">Profiteer van onze jarenlange ervaring en succesvolle aanpak</p>
                  </div>
                </div>
              </div>

              <Button href="/contact?onderwerp=samenwerking" variant="secondary" size="lg">
                Plan een Kennismaking
              </Button>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20handshake%20between%20diverse%20business%20partners%20in%20modern%20office%20setting%2C%20collaboration%20and%20partnership%20concept%2C%20bright%20meeting%20room%20with%20documents%20and%20laptops%2C%20successful%20business%20relationship&width=600&height=400&seq=herstart-samenwerking&orientation=landscape"
                alt="Samenwerking starten met HerStart"
                className="rounded-lg shadow-lg object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Samen Maken We Het Verschil
          </h2>
          <p className="text-xl text-orange-100 mb-8 max-w-3xl mx-auto">
            Sluit u aan bij ons netwerk van partners die zich inzetten voor 
            een betere toekomst voor thuiszittende jongeren.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button href="/contact?onderwerp=bedrijfspartner" variant="secondary" size="lg">
              Word Partner
            </Button>
            <Button href="/doe-mee" variant="outline" size="lg" className="bg-white text-orange-500 border-white hover:bg-orange-50">
              Andere Manieren om te Helpen
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SamenwerkingenPage;
